var map = {
	"./001_storesace/logo.png": "7035",
	"./006_maissabor/logo.png": "3634",
	"./008_cacula/logo.png": "98d5",
	"./009_carpediem/logo.png": "7e8e",
	"./010_degema/logo.png": "dc9b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "faab";